export default {
    namespaced: true,

    state: {
        textInfoModal: "",
        showSuccessModal: false,
        showDeclineModal: false,
    },
    getters: {
        getTextInfoModal: (state) => state.textInfoModal,
        getShowSuccessModal: (state) => state.showSuccessModal,
        getShowDeclineModal: (state) => state.showDeclineModal,
    },
    mutations: {
        SET_TEXT_INFO: (state, data) => {
            state.textInfoModal = data.text;

            setTimeout(() => {
                state.textInfoModal = "";
            }, data.time);
        },
        SET_SUCCESS: (state, data) => {
            state.showSuccessModal = data;
        },
        SET_DECLINE: (state, data) => {
            state.showDeclineModal = data;
        },
    },
};
